import { motion } from "framer-motion";
import { useState } from "react";

export default function Testimonials() {
  const [hovered, setHovered] = useState(null);

  const testimonials = [
    {
      name: "Michael Thompson",
      position: "IT Manager, TechCorp",
      feedback:
        "Basore Technologies transformed our IT infrastructure. The team is professional, responsive, and extremely knowledgeable. Downtime is now practically zero!",
    },
    {
      name: "Sarah Lee",
      position: "CEO, FinSolutions",
      feedback:
        "Thanks to Basore’s proactive network monitoring and cybersecurity services, our operations are secure and efficient. Highly recommended!",
    },
    {
      name: "Rajesh Kumar",
      position: "CTO, CloudNova",
      feedback:
        "Their cloud migration and server management expertise is top-notch. Basore Technologies streamlined our workflows and saved us significant costs.",
    },
  ];

  return (
    <section className="relative bg-[#0f111a] py-24 px-6 md:px-16 text-white overflow-hidden">
      <div className="max-w-6xl mx-auto text-center">
        {/* Section Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-4xl md:text-5xl font-extrabold mb-10 bg-clip-text text-transparent bg-gradient-to-r from-[#00fff7] to-[#0077ff]"
        >
          What Our Clients Say
        </motion.h2>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testi, i) => (
            <motion.div
              key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              animate={{
                scale: hovered === i ? 1.04 : 1,
                y: hovered === i ? -4 : 0,
                boxShadow:
                  hovered === i
                    ? "0px 8px 22px rgba(0, 119, 255, 0.25)"
                    : "0px 4px 12px rgba(0, 0, 0, 0.2)",
              }}
              transition={{
                duration: 0.35,
                ease: [0.23, 1, 0.32, 1],
              }}
              className="relative bg-[#1a1f2b]/80 border border-gray-800 hover:border-[#00fff7] rounded-2xl p-8 cursor-pointer transition-all duration-300"
            >
              {/* Subtle glow overlay */}
              <motion.div
                className="absolute inset-0 rounded-2xl pointer-events-none"
                animate={{
                  boxShadow:
                    "0 0 20px rgba(0,255,247,0.08), 0 0 30px rgba(0,119,255,0.08)",
                }}
                transition={{
                  repeat: Infinity,
                  duration: 5,
                  ease: "easeInOut",
                  repeatType: "mirror",
                }}
              ></motion.div>

              {/* Content */}
              <div className="relative z-10 text-left">
                <p className="text-gray-300 mb-6 italic leading-relaxed">
                  “{testi.feedback}”
                </p>
                <h3 className="text-xl font-semibold text-[#00fff7] mb-1">
                  {testi.name}
                </h3>
                <p className="text-gray-400 text-sm">{testi.position}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Call-to-Action */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 1 }}
          className="mt-16 text-center"
        >
          <p className="text-gray-300 mb-4 text-lg">
            Want to experience the same high-quality IT solutions?
          </p>
          <motion.a
            href="#contact"
            whileHover={{
              scale: 1.07,
              boxShadow: "0 0 18px rgba(0,255,247,0.35)",
              background: "linear-gradient(90deg, #00fff7, #0077ff)",
            }}
            transition={{
              type: "spring",
              stiffness: 250,
              damping: 20,
            }}
            className="inline-block bg-gradient-to-r from-[#00fff7] to-[#0077ff] text-black 
                       font-semibold px-8 py-3 rounded-full shadow-md hover:shadow-lg 
                       transition-all duration-300"
          >
            Get in Touch
          </motion.a>
        </motion.div>
      </div>

      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-[#0f111a]/15 via-[#1a1f2b]/10 to-[#0f111a]/15 pointer-events-none -z-10"></div>
    </section>
  );
}
